/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Need_PhotosInputs */

const en_directory_ai_tools_studio_need_photos = /** @type {(inputs: Directory_Ai_Tools_Studio_Need_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add both photos first.`)
};

const zh_directory_ai_tools_studio_need_photos = /** @type {(inputs: Directory_Ai_Tools_Studio_Need_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先上传两张照片。`)
};

/**
* | output |
* | --- |
* | "Add both photos first." |
*
* @param {Directory_Ai_Tools_Studio_Need_PhotosInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_need_photos = /** @type {((inputs?: Directory_Ai_Tools_Studio_Need_PhotosInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Need_PhotosInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_need_photos(inputs)
	return zh_directory_ai_tools_studio_need_photos(inputs)
});
export { directory_ai_tools_studio_need_photos as "directory.ai_tools.studio.need_photos" }